import request from '@teetsh/app/src/utils/request';
import { useMutation } from '@tanstack/react-query';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useTranslation } from 'react-i18next';
import { DisplayConfig } from 'containers/Programmations/ProgV2/atoms';
import { NiveauValue } from 'containers/scholarSystem';
import { shortenUUID } from '@teetsh/app/src/utils/shortenUUID';
import { PrintConfig } from '../ProgV2/Preview/types';

interface Props {
  schoolyearId: string;
  schoolId: string;
  programmationId: string;
  destProgId: string;
  displayConfig: DisplayConfig;
  printConfig: PrintConfig;
  grade: NiveauValue;
}

function sharePubliclyProgrammation({
  schoolyearId,
  schoolId,
  programmationId,
  displayConfig,
  printConfig,
  grade,
  destProgId,
}: Props) {
  const url = new URL(
    `${
      import.meta.env.VITE_API_URL
    }/schoolyears/${schoolyearId}/schools/${schoolId}/programmations/${programmationId}/public-share`,
  );

  const hiddenPeriodes = displayConfig.hiddenPeriodes
    .map(shortenUUID)
    .join(',');
  const hiddenDomaines = displayConfig.hiddenDomaines
    .map(shortenUUID)
    .join(',');
  const matiereIds = printConfig.matiereIds.map(shortenUUID).join(',');

  const params = new URLSearchParams({
    view: printConfig.view,
  });
  if (hiddenPeriodes) {
    params.append('hiddenPeriodes', hiddenPeriodes);
  }
  if (hiddenDomaines) {
    params.append('hiddenDomaines', hiddenDomaines);
  }
  if (matiereIds) {
    params.append('matiereIds', matiereIds);
  }

  url.search = params.toString();

  return request(url.toString(), {
    method: 'POST',
    body: {
      grade,
      destProgId,
    },
  });
}

export function useSendToCMSProgrammation() {
  const { schoolyear, school } = useSchoolSchoolyear();
  const { notifyError } = useNotification();
  const { t } = useTranslation(['programmation']);
  const { mutateAsync, isPending: isLoading } = useMutation({
    mutationFn: ({
      programmationId,
      destProgId,
      displayConfig,
      printConfig,
      grade,
    }: {
      programmationId: string;
      destProgId: string;
      displayConfig: DisplayConfig;
      printConfig: PrintConfig;
      grade: NiveauValue;
    }) =>
      sharePubliclyProgrammation({
        programmationId,
        schoolId: school.id,
        schoolyearId: schoolyear.id,
        displayConfig,
        printConfig,
        grade,
        destProgId,
      }),

    onSuccess: () => {},
    onError: () => {
      notifyError({
        title: t('programmation:messages.programmation.shareError'),
      });
    },
  });
  return { sendToCMS: mutateAsync, isLoading };
}
